import { Drawer, List, Timeline, Typography } from 'antd'
import { Trans, useTranslation } from 'react-i18next'

export function HelpDrawer ({ prefix, ...props }) {
  const i18n = useTranslation('translation', { keyPrefix: `${prefix}.help` })
  const body = i18n.t('body', { returnObjects: true }).map((section, index) => {
    const key = [section.type, index].join('-')
    switch (section.type) {
      case 'title': {
        return <Typography.Title key={key} level={section.level}><Trans>{section.text}</Trans></Typography.Title>
      }
      case 'paragraph': {
        return <Typography.Paragraph key={key}><Trans>{section.text}</Trans></Typography.Paragraph>
      }
      case 'timeline': {
        const items = section.items
          .map((text, index) => <Typography.Text key={index}><Trans>{text}</Trans></Typography.Text>)
          .map((content, index) => <Timeline.Item key={index}>{content}</Timeline.Item>)
        return <Timeline key={key}>{items}</Timeline>
      }
      case 'list': {
        const items = section.items
          .map((text, index) => <Typography.Text key={index}><Trans>{text}</Trans></Typography.Text>)
          .map((content, index) => <List.Item key={index}>{index + 1}. {content}</List.Item>)
        return <List key={key} size='small'>{items}</List>
      }
      default:
        return null
    }
  })
  let footer = null
  if (i18n.t('footer', { returnDetails: true }).usedLng !== 'dev') {
    const components = { 'external-link': <a href={i18n.t('footer.link')} target='_blank' rel='noreferrer' /> }
    const text = <Trans i18nKey={`${prefix}.help.footer.content`} components={components} />
    footer = <Typography.Text>{text}</Typography.Text>
  }
  return <Drawer placement='right' {...props} footer={footer}>{body}</Drawer>
}
